<!-- eslint-disable -->
<template>
    <el-container>
        <el-row class="list-container">
            <el-col :span="24">
                <el-button @click="refreshData" type="primary" size="small" icon="iconfont icon-shuaxin shuaxin">刷新</el-button>
                <el-button type="success" size="small" icon="iconfont icon-daochu shuaxin" @click="exportExcel">导出Excel</el-button>
                <!-- <el-button type="primary" size="small" icon="iconfont icon-jia shuaxin" @click="dialogFormVisible = true">新增</el-button> -->
                <!-- <el-button @click="delMultiple" type="danger" size="small" icon="iconfont icon-shanchu shuaxin">删除</el-button> -->
            </el-col>

            <!-- search start  -->
            <el-col :span="24" class="search-content">
                <div class="search-item" style="width: 130px;">
                    <el-select v-model="data.staff_date" placeholder="请选择月份" size="small">
                        <el-option
                            v-for="item in dateList"
                            :key="item.staff_date"
                            :label="item.title"
                            :value="item.staff_date">
                        </el-option>
                    </el-select>
                </div>
                <div class="search-item">
                    <el-button size="small" icon="iconfont icon-fangdajing shuaxin" @click="search">搜索</el-button>
                </div>
            </el-col>
            <!-- search end  -->

            <el-col class="main-content">
                <el-table :data="dataList" border v-loading="loading" style="width: 100%">
                    <!-- <el-table-column type="selection" width="55"></el-table-column> -->
                    <!-- <el-table-column prop="id" label="ID" width="80"></el-table-column> -->

                    <el-table-column prop="staff_date" label="月份" width="180"></el-table-column>
                    <el-table-column prop="staff_name" label="员工" width="180"></el-table-column>
                    <el-table-column prop="j_petrol_money" label="加油金额-汽油" width="180"></el-table-column>
                    <el-table-column prop="j_diesel_money" label="加油金额-柴油" width="180"></el-table-column>
                    <el-table-column prop="c_petrol_money" label="充值金额-汽油" width="180"></el-table-column>
                    <el-table-column prop="c_diesel_money" label="充值金额-柴油" width="180"></el-table-column>
                    <el-table-column prop="total_money" label="总金额" min-width="180"></el-table-column>

                    <!-- <el-table-column label="操作" min-width="180">
                        <template slot-scope="scope">
                            <el-button @click="editTmp(scope.row)" icon="iconfont icon-bianji shuaxin" type="primary" size="mini" plain>编辑</el-button>
                            <el-button @click="del(scope.row.id)" icon="iconfont icon-shanchu shuaxin" size="mini" type="danger" plain>删除</el-button>
                        </template>
                    </el-table-column> -->
                </el-table>
            </el-col>
            <el-col class="pagination">
                <el-pagination
                    @current-change="changePage"
                    @size-change="changePageSize"
                    background
                    :layout="pageLayout"
                    :page-sizes="pagePageSizes"
                    :page-size="pagePageSize"
                    :total="totalCount"
                    :current-page.sync="current_page"
                    :hide-on-single-page="false">
                </el-pagination>
            </el-col>
        </el-row>
    </el-container>
</template>

<!-- eslint-disable -->
<script>
    import {StaffStsIndex} from "@/utils/request.js"
    import {mapState} from "vuex"

    export default {
        data(){
            return {
                data: {
                    page: 1,
                    page_size: this.pagePageSize,
                    staff_date: '',
                    searchText: '',
                },
                loading: false,
                dataList: [],
                totalCount: 0,
                current_page: 1,
                dialogFormVisible: false,
                loadingAdd: false,
                formLabelWidth: "120px",
                form: {
                    id: 0,
                    staff_id: "",
                },
                multipleSelection: [],
                dateList: []
            }
        },
        created() {
            this.getList()
        },
        computed: mapState(["power", "loginInfo"]),
        methods: {
            search() {
                this.data.page = 1
                this.current_page = 1
                this.getList()
            },
            refreshData() {
                this.data.page = 1
                this.current_page = 1
                this.loading = true

                this.getList()
            },
            getList() {
                this.loading = true
                StaffStsIndex(this.data).then((res) => {
                    if (res.code == 200) {
                        this.data.page++
                        this.dataList = res.data.data
                        this.totalCount = res.data.count
                        this.dateList = res.data.dateList
                    } else {
                        this.$message.error("数据获取失败!")
                    }
                    this.loading = false
                })
            },
            changePage(page) {
                this.data.page = page
                this.getList()
            },
            changePageSize(size) {
                this.data.page_size = size
                this.data.page = 1
                this.current_page = 1
                this.getList()
            },
            exportExcel(type) {
              this.$confirm("确定要导出列表数据吗?", "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "success"
              }).then(() => {
                  let url = '';
                  for(var k in this.data){
                    let value = this.data[k] !==undefined ? this.data[k] : '';
                    if (k == 'page') { continue }
                    url += `&${k}=${encodeURIComponent(value)}`
                  }
                  url += `&type=${type}`
                  location.href = this.loginInfo.app_url+'/manage/staff-sts/excel?' + url.substring(1)
              }).catch(() => {
                  // 取消操作
              });
            },
        }
    }
</script>

<style>
</style>
